import { Almanac } from "protos/robot_syncer/plant_profile";
import {
  almanacFromTypeCategory,
  getAlmanacCategoryForFixedName,
} from "portal/utils/categoryCollection/category";
import { type AlmanacGroup } from "portal/components/categoryTemplates/useAlmanacOptions";
import { TFunction } from "i18next";

export type ResolveAlmanacCategorySuccess = {
  ok: true;
  almanac: Almanac;
};

export type ResolveAlmanacCategoryFailure = {
  ok: false;
  field: "sourceAlmanacId" | "mostSimilarTo";
  message: string;
};

export type ResolveAlmanacCategoryResult =
  | ResolveAlmanacCategorySuccess
  | ResolveAlmanacCategoryFailure;

export const resolveAlmanacCategory = (
  almanacGroups: AlmanacGroup[],
  sourceAlmanacId: string,
  mostSimilarTo: string,
  t: TFunction
): ResolveAlmanacCategoryResult => {
  const sourceAlmanac = almanacGroups
    .flatMap((group) => group.almanacs)
    .find((almanac) => almanac.id === sourceAlmanacId);
  if (!sourceAlmanac) {
    return {
      ok: false,
      field: "sourceAlmanacId",
      message: t("utils.form.required"),
    };
  }

  const almanacCategory = getAlmanacCategoryForFixedName(
    sourceAlmanac,
    mostSimilarTo
  );
  if (!almanacCategory) {
    return {
      ok: false,
      field: "mostSimilarTo",
      message: t("components.categoryTemplates.errors.missingAlmanacCategory"),
    };
  }

  return { ok: true, almanac: almanacFromTypeCategory(almanacCategory) };
};
